// extracted by mini-css-extract-plugin
export default {"container":"Progress-module__container--5dd5"};